import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CLAOption } from '../../CLA/SalaryScales/types';
import { IHolidaysSpecial } from './types';

import { claDataToOption, schemaForHolidaysSpecial } from './utils';

import { SPECIALS_HOLIDAYS } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { LoadingButton } from '@mui/lab';

import { ControlledDatePicker, ControlledSelect } from 'components/shared';
import TextField from 'components/shared/ControlledFields/ControlledTextField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

type Props = {
  data?: IHolidaysSpecial;
  claData: CLAOption[];
  handleClose: () => void;
};

export const HolidaySpecialForm = ({ data, claData, handleClose }: Props) => {
  const { t } = useTranslation('common');

  const { mutateAsync: mutate, isLoading } = useSaveResource({
    url: SPECIALS_HOLIDAYS,
    id: data?.holidaySpecialId,
    invalidateQueryKey: ['holidays-special']
  });

  const methods = useForm<IHolidaysSpecial>({
    defaultValues: {
      ...data,
      claId: data?.claId ?? null,
      description: data?.description ?? ''
    },
    resolver: yupResolver(schemaForHolidaysSpecial(t)),
    mode: 'onChange'
  });

  const { control, handleSubmit } = methods;

  const onSubmit = (data: IHolidaysSpecial) => {
    mutate(data);
    handleClose();
  };

  return (
    <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <MultiStepForm.Section
        title={t('adminPortal.baseSelection')}
        validateFields={['date', 'description', 'claId']}
      >
        <ControlledDatePicker
          label={t('adminPortal.tables.date')}
          variant={'outlined'}
          name={'date'}
          control={control}
        />
        <TextField
          label={t('name')}
          variant={'outlined'}
          name={'description'}
          control={control}
        />
        <ControlledSelect
          label={t('adminPortal.tables.cla')}
          variant={'outlined'}
          options={claDataToOption(claData)}
          name={'claId'}
          control={control}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};
